export default "__VITE_ASSET__C5xW1fZ7__"